import React from 'react'

import MenuButton from 'react-md/lib/Menus/MenuButton'
import FontIcon from 'react-md/lib/FontIcons'
import ListItem from 'react-md/lib/Lists/ListItem'

import ACL from 'components/common/ACL'

const link = {
	properties: {
		title: "",
		subtitle: "",
		url: "http://"
	}
};

const contact = {
	properties: {
		pictureUrl: "",
		firstName: "",
		lastName: "",
		companyName: "",
		role: "",
		address_street: "",
		address_zip: "",
		address_city: "",
		address_country: "",
		phone_mobile: "",
		email_office: "",
		url: ""
	}
};

const feedback = {
	properties: {
		title: "",
		inputType: "",
		value: "",
		items: []
	}
};

export default ({ actionHandler }) => (
	<MenuButton
		id="add-button"
		floating
		primary
		fixed
		block
		menuItems={[
			<ACL allow="bundle-image-edit" key="image">
				<ListItem
					primaryText="Bild hinzufügen"
					leftIcon={<FontIcon>add_a_photo</FontIcon>}
					onClick={() => actionHandler.selectFile("image", {accept: "image/*"})}
				/>
			</ACL>,
			<ACL allow="bundle-video-edit" key="video">
				<ListItem
					primaryText="Video hinzufügen"
					leftIcon={<FontIcon>videocam</FontIcon>}
					onClick={() => actionHandler.selectFile("video", {accept: "video/*"})}
				/>
			</ACL>,
			<ACL allow="bundle-document-edit" key="document">
				<ListItem
					primaryText="PDF-Dokument hinzufügen"
					leftIcon={<FontIcon>note_add</FontIcon>}
					onClick={() => actionHandler.selectFile("document", {accept: "application/pdf"})}
				/>
			</ACL>,
			<ACL allow="bundle-link-edit" key="link">
				<ListItem
					primaryText="Web-Link hinzufügen"
					leftIcon={<FontIcon>link</FontIcon>}
					onClick={() => actionHandler.addNodeToPayload("link", link)}
				/>
			</ACL>,
			<ACL allow="bundle-feedback-edit" key="feedback">
				<ListItem
					primaryText="Feedback hinzufügen"
					leftIcon={<FontIcon>feedback</FontIcon>}
					onClick={() => actionHandler.addNodeToPayload("feedback", feedback)}
				/>
			</ACL>,
			<ACL allow="bundle-contact-edit" key="contact">
				<ListItem
					primaryText="Kontakt hinzufügen"
					leftIcon={<FontIcon>contact_mail</FontIcon>}
					onClick={() => actionHandler.addNodeToPayload("contact", contact)}
				/>
			</ACL>
		]}
		simplifiedMenu={false}
		anchor={{
			x: MenuButton.HorizontalAnchors.LEFT,
			y: MenuButton.VerticalAnchors.TOP,
		}}
	>
		add
	</MenuButton>
);


// WEBPACK FOOTER //
// ./src/components/bundle/v1/BundleActions.jsx